import {FC, memo, useEffect} from 'react'
import {InputStepErr, InputStepInputCopyPasteType, InputStepMode} from '..'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

export type InputStepNumberOrCustomProps = {
  inputMode: InputStepMode
  copyPasteType: InputStepInputCopyPasteType
  customData: string
  numberData: string
  error: InputStepErr
  setError: (error: InputStepErr) => void
  setCopyPasteType: (type: InputStepInputCopyPasteType) => void
  setInputMode: (mode: InputStepMode) => void
  setNumberData: (data: string) => void
  setCustomData: (data: string) => void
}
const InputStepNumberOrCustom: FC<InputStepNumberOrCustomProps> = (props) => {
  const {
    error,
    copyPasteType,
    customData,
    numberData,
    inputMode,
    setInputMode,
    setCopyPasteType,
    setCustomData,
    setNumberData,
    setError,
  } = props

  return (
    <div className='fv-row mb-10 mt-5'>
      <div className='form-check form-check-custom form-check-solid'>
        <input
          className='form-check-input mb-6'
          type='radio'
          value=''
          id='flexRadioChecked'
          checked={inputMode === InputStepMode.CopyPaste}
          onChange={() => setInputMode(InputStepMode.CopyPaste)}
        />
        <label
          className='form-check-label align-items-start flex-column d-flex ms-3'
          htmlFor='flexRadioChecked'
        >
          <span className='card-label fw-bolder fs-5'>Copy and Paste list</span>
          <span className=' fs-7'>
            <div className='text-muted'>
              Paste your client data in without creating a list. Follow format and sequence as
              outlined below, each subscriber to fall on a new line.
            </div>

            <div className='mt-2 text-bold'>
              {copyPasteType === InputStepInputCopyPasteType.Number ? (
                'Eg: Number, Number, Number, Number, Number, Number, Number'
              ) : (
                <>
                  Mobile Number, FirstName, Lastname
                  <br />
                  Mobile Number, FirstName, Lastname
                  <br />
                  Mobile Number, FirstName, Lastname
                  <br />
                </>
              )}
            </div>
          </span>
        </label>
      </div>
      {inputMode === InputStepMode.CopyPaste && (
        <>
          <div className='form-check form-check-custom form-check-sm form-check-solid ms-10 mt-3'>
            <div className='row w-100'>
              <div className=' w-100 d-flex  align-items-center justify-content-between mb-3'>
                <div className='row w-100'>
                  <input
                    className='form-check-input mb-3 col-2 margin-remove'
                    type='radio'
                    value=''
                    id='flexRadioChecked1'
                    style={{
                      margin: '0px !important',
                    }}
                    checked={copyPasteType === InputStepInputCopyPasteType.Number}
                    onChange={() => {
                      setCopyPasteType(InputStepInputCopyPasteType.Number)
                      setCustomData('')
                    }}
                  />
                  <label
                    className='form-check-label align-items-start flex-column d-flex ms-0 col-6'
                    htmlFor='flexRadioChecked1'
                  >
                    <span className='card-label fw-bold fs-5'>Number Only</span>
                  </label>
                </div>
                <div className='row w-100'>
                  <input
                    className='form-check-input mb-6 col-2 margin-remove'
                    type='radio'
                    value=''
                    id='flexRadioChecked2'
                    checked={copyPasteType === InputStepInputCopyPasteType.Custom}
                    style={{
                      margin: '0px !important',
                    }}
                    onChange={() => {
                      setCopyPasteType(InputStepInputCopyPasteType.Custom)
                      setNumberData('')
                    }}
                  />

                  <OverlayTrigger
                    placement='top'
                    overlay={
                      <Tooltip>
                        <div className='text-start'>
                          Ensure each contact is listed on a separate line in the following format:{' '}
                          <br />
                          Mobile Number, FirstName, Lastname <br />
                          Mobile Number, FirstName, Lastname
                        </div>
                      </Tooltip>
                    }
                  >
                    <label
                      className='form-check-label align-items-start flex-column d-flex ms-0 col-8'
                      htmlFor='flexRadioChecked2'
                    >
                      <span className='card-label fw-bold fs-5'>Custom details</span>
                    </label>
                  </OverlayTrigger>
                </div>
              </div>
              {copyPasteType === InputStepInputCopyPasteType.Number ? (
                <>
                  <textarea
                    onBlur={() =>
                      numberData.trim() === '' &&
                      setError({...error, copyByNumber: 'Please insert data'})
                    }
                    onChange={(e: any) => {
                      setNumberData(e.target.value)
                      setError({...error, copyByDetails: '', copyByNumber: '', upload: ''})
                    }}
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Eg: Number, Number, Number, Number, Number, Number, Number'
                    rows={4}
                    value={numberData}
                  />
                  {error.copyByNumber !== '' && (
                    <span className='text-danger mt-2'>{error.copyByNumber}</span>
                  )}
                </>
              ) : (
                <>
                  <textarea
                    onBlur={() => {
                      customData.trim() === '' &&
                        setError({...error, copyByDetails: 'Please insert data'})
                    }}
                    onChange={(e: any) => {
                      setCustomData(e.target.value)
                      setError({...error, copyByDetails: '', upload: '', copyByNumber: ''})
                    }}
                    className='form-control form-control-lg form-control-solid'
                    placeholder={`Mobile Number, FirstName, Lastname  
Mobile Number, FirstName, Lastname
Mobile Number, FirstName, Lastname`}
                    rows={4}
                    value={customData}
                  />
                  <span className='text-danger mt-3 gray-muted'>
                    Ensure each contact is listed on a separate line in the following format: Mobile
                    Number, First Name, Last Name, Gender, Postal Code, Date of Birth, Custom Field
                    1. The first line is treated as the first data entry. The placeholder serves as
                    an example and should be replaced with the correct format for your data.
                  </span>
                  {error.copyByDetails !== '' && (
                    <span className='text-danger mt-2'>{error.copyByDetails}</span>
                  )}
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default memo(InputStepNumberOrCustom)
